export default __webpack_public_path__ + "static/media/drishtiLogo.472c66ec.svg";